export default __webpack_public_path__ + "static/media/p5.31f707d3.jpg";